import Image from 'next/image';
import IconThemePrimary from './gear_theme_primary.svg?url';
import type { SvgImageProps } from '../types';

export const GearThemePrimaryImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconThemePrimary} alt={alt} {...props} />;
